import React,{useState,useEffect} from 'react';
import {ResponsiveSliderTop} from "../../../utils/constant";
import {getListBanner} from "../../../service/campaignService";
import Images from '../../Images';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const SliderV1= ({serverData}) =>{
    const [dataItems, setDataItems] = useState([]);
      if(serverData.length > 0){
    return(
        <>
        <Carousel 
        ssr={true}
         responsive = {ResponsiveSliderTop}
         showDots={true}
         autoPlay={true}
         autoPlaySpeed={3000}
         infinite={true}
         swipeable={true}
         
         >      
            {
                serverData.map((item,i)=>{
                return <div key={i}>
                        <a href={item?.link} title={item.name} >
                            <Images imgTitle={item?.name} url={item.images} className="slider--top" style=""/>
                        </a>
                    </div>
                })
            }      
        </Carousel>
        </>
    );
    }else{ return null}  
}

export default SliderV1